import { Skeleton } from "@shared/components";

import {
  CarouselActions,
  CarouselCard,
  CarouselDone,
  CarouselProgress,
} from "./components";

import type { PendenciesCarouselProps } from "./pendencies-carousel.type";
import styles from "./pendencies-carousel.module.css";

export const PendenciesCarousel = ({
  isLoading,
  transitionState,
  done,
  total,
  current,
  currentIdx,
  progressPct,
  canUndo,
  totalImpact,
  remaining,
  acceptedCount,
  skippedCount,
  resolve,
  undo,
  handleReview,
}: PendenciesCarouselProps) => {
  if (isLoading) {
    return (
      <div className={styles.container}>
        <Skeleton height="2.5rem" width="100%" />
        <Skeleton height="13rem" width="100%" />
      </div>
    );
  }

  if (done) {
    return (
      <div className={styles.container}>
        <CarouselDone
          acceptedCount={acceptedCount}
          skippedCount={skippedCount}
          totalImpact={totalImpact}
          total={total}
          onReview={handleReview}
        />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <CarouselProgress
        currentIdx={currentIdx}
        total={total}
        acceptedCount={acceptedCount}
        skippedCount={skippedCount}
        progressPct={progressPct}
      />

      {current && (
        <CarouselCard
          item={current}
          transitionState={transitionState}
        />
      )}

      <CarouselActions
        onSkip={() => resolve("skip")}
        onAccept={() => resolve("accept")}
        onUndo={undo}
        canUndo={canUndo}
        disabled={!!transitionState || remaining === 0}
      />
    </div>
  );
};
